import { gql } from '@apollo/client'

export const createSelectedOffer = gql`
  mutation createOffer($offerInput: Credit_BusinessCredit_CreateOfferInput!) {
    credit {
      businessCredit {
        createOffer(input: $offerInput) {
          offer {
            id
            formattedTerm {
              formattedTimeDuration(formatOptions: { style: LONG, unit: DAY })
            }
            formattedAmount {
              amount(formatOptions: { style: SYMBOL })
            }
            formattedAverageMonthlyCost {
              amount(formatOptions: { style: SYMBOL })
            }
            formattedAnnualPercentageRate {
              percentage
            }
          }
        }
      }
    }
  }
`

export const acceptSelectedOffer = gql`
  mutation createOffer($offerInput: Credit_BusinessCredit_AcceptOfferInput!) {
    credit {
      businessCredit {
        acceptOffer(input: $offerInput) {
          offerId
          applicationId
        }
      }
    }
  }
`
